import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface InlineInputBoxSendMessageCommandProperties extends CommandProperties {
  prompt: string;
  source: string;
  productKey: string;
  deepResearchEnabled: boolean;
  webSearchEnabled: boolean;
  contentId: string | number | undefined;
  openChat?: boolean;
  addCurrentPageAsContextUserPreference?: boolean;
  creationContextParams?: {
    shouldUseExistingContent?: boolean;
  };
}

/**
 * Command sent from databases to the Rovo chat panel to send a message and optionally
 * open the Rovo side panel after streaming completes.
 */
export const InlineInputBoxSendMessageCommand =
  createCommand<InlineInputBoxSendMessageCommandProperties>(
    'inline-input-box-send-message-command',
  );
